import { render, staticRenderFns } from "./ObjectGalleryBlock.vue?vue&type=template&id=2cfb1fb2&scoped=true&"
import script from "./ObjectGalleryBlock.vue?vue&type=script&lang=js&"
export * from "./ObjectGalleryBlock.vue?vue&type=script&lang=js&"
import style0 from "./ObjectGalleryBlock.vue?vue&type=style&index=0&id=2cfb1fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb1fb2",
  null
  
)

export default component.exports